import images from './imagesData';

const techStack = [
    {
        icon: images.html,
        name: 'HTML'
    },
    {
        icon: images.css,
        name: 'CSS'
    },
    {
        icon: images.sass,
        name: 'SCSS'
    },
    {
        icon: images.bootstrap,
        name: 'Bootstrap'
    },
    {
        icon: images.javascript,
        name: 'JavaScript'
    },
    {
        icon: images.jquery,
        name: 'JQuery'
    },
    {
        icon: images.threejs,
        name: 'Three.js'
    },
    {
        icon: images.react,
        name: 'React'
    },
    {
        icon: images.git,
        name: 'Git'
    },
    {
        icon: images.github,
        name: 'Github'
    },
    // {
    //     icon: images.node,
    //     name: 'Node.js'
    // },
]

export default techStack;